import { render, staticRenderFns } from "./FreeProductSetMenu.vue?vue&type=template&id=137c72c6&scoped=true&"
import script from "./FreeProductSetMenu.vue?vue&type=script&lang=js&"
export * from "./FreeProductSetMenu.vue?vue&type=script&lang=js&"
import style0 from "./FreeProductSetMenu.vue?vue&type=style&index=0&id=137c72c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137c72c6",
  null
  
)

export default component.exports